import { APIResponseType } from '../types';
import { Resource } from '../../pages/RoleManagementPage/types';
import apiService from '..';

interface AttachRolesAndScopesRequest {
  roles: string[];
  scopes: string[];
}

interface ResourceRolesAndScopesResponse {
  roles: string[];
  scopes: string[];
}

class ResourceApiService {
  static ENDPOINT = 'api/v2/resources';

  static async createResource(resource: Partial<Resource>): Promise<APIResponseType> {
    try {
      const response = await apiService.post<APIResponseType>(`${this.ENDPOINT}`, JSON.stringify(resource));
      return response;
    } catch (error) {
      throw error;
    }
  }

  static async addResource(resource: Partial<Resource>): Promise<APIResponseType> {
    try {
      const response = await apiService.post<APIResponseType>(`${this.ENDPOINT}`, resource);
      await apiService.invalidateCacheByPrefix(`${this.ENDPOINT}`, 'GET');
      return response;
    } catch (error) {
      throw error;
    }
  }

  static async deleteResource(resourceId: string): Promise<APIResponseType> {
    try {
      const response = await apiService.delete<APIResponseType>(`${this.ENDPOINT}/${resourceId}`);
      await apiService.invalidateCacheByPrefix(`${this.ENDPOINT}`, 'GET');
      return response;
    } catch (error) {
      throw error;
    }
  }

  static async editResource(resourceId: string, data: Partial<Resource>): Promise<APIResponseType> {
    try {
      const response = await apiService.put<APIResponseType>(`${this.ENDPOINT}/${resourceId}`, data);
      await apiService.invalidateCacheByPrefix(`${this.ENDPOINT}`, 'GET');
      return response;
    } catch (error) {
      throw error;
    }
  }

  static async getResource(resourceId: string): Promise<APIResponseType> {
    try {
      const response = await apiService.get<APIResponseType>(`${this.ENDPOINT}/${resourceId}`);
      return response;
    } catch (error) {
      throw error;
    }
  }

  static async getAllResources(): Promise<APIResponseType> {
    try {
      const response = await apiService.get<APIResponseType>(this.ENDPOINT);
      return response;
    } catch (error) {
      throw error;
    }
  }

  static async attachRolesAndScopes(
    resourceId: string,
    data: AttachRolesAndScopesRequest
  ): Promise<APIResponseType> {
    try {
      const response = await apiService.put<APIResponseType>(`${this.ENDPOINT}/attach-roles-and-scopes/${resourceId}`, data);
      await apiService.invalidateCacheByPrefix(`${this.ENDPOINT}`, 'GET');
      return response;
    } catch (error) {
      throw error;
    }
  }

  static async getResourceRolesAndScopes(resourceId: string): Promise<APIResponseType<ResourceRolesAndScopesResponse>> {
    try {
      const response = await apiService.get<APIResponseType<ResourceRolesAndScopesResponse>>(`${this.ENDPOINT}/roles-and-scopes/${resourceId}`);
      return response;
    } catch (error) {
      throw error;
    }
  }
}

export default ResourceApiService; 